import { useQuery } from "@apollo/client";
import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import DialogModal from "src/components/Dialog";
import { GetAsoEbiAttires } from "src/graphql/queries";
import { cn } from "src/lib/utils";
import useAppStore from "src/store/utils";
import {
  Aseobi,
  GetAseobiAttires,
  GetAseobiAttiresVariables,
} from "src/utils/gql_types";
import { GroupIcon, Pencil, Trash } from "../../Icons";
import EditGroup from "../../modals/EditGroup";
import DeleteGroup from "../../modals/RemoveGroup";
import groupCard from "./groupCard.module.scss";

interface GroupCardProps {
  group: Aseobi;
}

const GroupCard: React.FC<GroupCardProps> = ({ group }) => {
  const { event } = useAppStore((state) => state);
  const navigate = useNavigate();

  const { data: asoebiAttires } = useQuery<
    GetAseobiAttires,
    GetAseobiAttiresVariables
  >(GetAsoEbiAttires, {
    variables: {
      event_id: event.uuid,
      aseobi_id: group.id,
    },
    fetchPolicy: "cache-and-network",
    onError(error) {
      if (error?.message !== "unauthenticated") {
        toast.error(<p>{error?.message ?? "An error occurred"}</p>);
      } else {
        navigate("/clear");
      }
    },
  });

  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  return (
    <div className="relative">
      <Link
        to={`/aso-ebi/${group?.id}?groupName=${group.name}`}
        className={`${groupCard["groupCard"]} shadow-[0_0_10px_2px_rgba(0,0,0,0.05)] transition-all duration-300 ease-in-out hover:scale-[1.015] hover:shadow-[0_5px_15px_rgba(0,0,0,0.1)]`}
      >
        <div className={groupCard["groupCard__circle__group"]}>
          {asoebiAttires?.getAseobiAttires.length !== 0 ? (
            <div className="flex w-full items-center justify-start rounded-md">
              {asoebiAttires?.getAseobiAttires.slice(0, 3).map((attire) => (
                <div key={attire.id} className="h-16 w-16 rounded-md">
                  {attire.images && (
                    <img
                      src={attire.images[0]}
                      alt="..."
                      className="h-full w-full rounded-md transition duration-500 hover:scale-[1.05]"
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <GroupIcon />
          )}
        </div>

        <div className={cn(groupCard["groupCard__bottom"])}>
          {/* <h4>Groom&apos;s family Aso-ebi</h4> */}
          <h4>{group?.name === "regular" ? "Regular" : group?.name}</h4>
          <span className="text-sm">
            {asoebiAttires?.getAseobiAttires.length} items
          </span>
        </div>
      </Link>
      <div
        className={`${groupCard["groupCard__controls"]} absolute bottom-[85px] left-[20px]`}
      >
        <DialogModal
          open={editOpen}
          onOpenChange={setEditOpen}
          trigger={
            <button
              // to={`/aso-ebi/${group?.id}?name=${group.name}`}
              className="flex size-8 items-center justify-center border hover:bg-gray-200"
            >
              <Pencil />
            </button>
          }
        >
          <EditGroup id={group?.id} name={group?.name} setOpen={setEditOpen} />
        </DialogModal>
        <DialogModal
          open={open}
          onOpenChange={setOpen}
          trigger={
            <button className="flex size-8 items-center justify-center border hover:bg-gray-200">
              <Trash />
            </button>
          }
        >
          <DeleteGroup setOpen={setOpen} group={group} />
        </DialogModal>
      </div>
    </div>
  );
};

export default GroupCard;
